import Vue from 'vue';
import Vuex from 'vuex';
import { createProxy, extractVuexModule } from 'vuex-class-component';
import { RouterStore } from './router-store';
import { AppStore } from './app-store';
import { AllocationsStore } from './allocations-store';

Vue.use(Vuex);

// store.vuex.ts
export const store = new Vuex.Store({
    modules: {
        ...extractVuexModule(RouterStore),
        ...extractVuexModule(AppStore),
        ...extractVuexModule(AllocationsStore),
    },
});

// Creating proxies.
export const vxm = {
    route: createProxy(store, RouterStore),
    app: createProxy(store, AppStore),
    allocations: createProxy(store, AllocationsStore),
};
